(function () {
  /* ---------- Basket count badge ---------- */
  document.querySelectorAll('[data-ws-count]').forEach(function (e) {
    var sync = function () { e.hidden = !parseInt(e.textContent, 10); };
    new MutationObserver(sync).observe(e, { childList: true, characterData: true, subtree: true });
  });
  /* ---------- Symptom checklist ---------- */
  document.querySelectorAll('[data-ws-check]').forEach(function (box) {
    var out = box.querySelector('[data-ws-check-out]');
    var link = box.querySelector('[data-ws-check-link]');
    var rows = box.querySelectorAll('.ws-check__row');
    var start = out ? out.textContent : '';
    rows.forEach(function (r) {
      r.addEventListener('click', function () {
        var on = r.getAttribute('aria-pressed') !== 'true';
        r.setAttribute('aria-pressed', on ? 'true' : 'false');
        var n = box.querySelectorAll('.ws-check__row[aria-pressed="true"]').length;
        if (!out) return;
        if (n === 0) { out.textContent = start; if (link) link.hidden = true; return; }
        out.textContent = n + ' of ' + rows.length + '. These are common signs of tonsil stones.';
        if (link) link.hidden = false;
      });
    });
  });
  /* ---------- Reveal on scroll ---------- */
  var items = document.querySelectorAll('[data-ws-reveal]');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) { items.forEach(function (e) { e.classList.add('is-in'); }); return; }
  document.documentElement.classList.add('ws-js');
  var io = new IntersectionObserver(function (ents) {
    ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -12% 0px' });
  items.forEach(function (e) { io.observe(e); });
})();
(function () {
  var mq = window.matchMedia('(max-width: 760px)');
  /* ---------- Mobile swipe gallery ---------- */
  var col = document.querySelector('.ws-galcol');
  var fig = col && col.querySelector('figure');
  var thumbs = col ? col.querySelectorAll('[data-ws-thumb]') : [];
  if (fig && thumbs.length > 1) {
    var main = fig.querySelector('[data-ws-main]');
    var track = document.createElement('div'); track.className = 'ws-mtrack';
    var dots = document.createElement('div'); dots.className = 'ws-mdots';
    thumbs.forEach(function (t, i) {
      var img;
      if (i === 0 && main) { img = main.cloneNode(); img.removeAttribute('data-ws-main'); img.classList.remove('ws-rise'); }
      else { img = new Image(); img.loading = 'lazy'; img.decoding = 'async'; img.src = t.getAttribute('data-src'); img.alt = t.getAttribute('data-alt') || ''; img.width = 1400; img.height = 1400; }
      img.className = 'ws-mslide';
      track.appendChild(img);
      dots.appendChild(document.createElement('i'));
    });
    dots.firstChild.className = 'on';
    fig.appendChild(track); fig.appendChild(dots);
    col.classList.add('is-carousel');
    var last = 0;
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== last) { dots.children[last].className = ''; dots.children[i] && (dots.children[i].className = 'on'); last = i; }
    }, { passive: true });
  }
  /* ---------- Sticky add to basket ---------- */
  var bar = document.querySelector('.ws-sticky');
  var anchor = document.querySelector('#ws-form [type="submit"]') || document.querySelector('main section');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (ents) {
      var e = ents[0];
      bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(anchor);
  } else if (bar) { bar.classList.add('is-on'); }
  /* ---------- Review arrows ---------- */
  document.querySelectorAll('[data-ws-voices]').forEach(function (tr) {
    var sec = tr.closest('section');
    function go(d) { var c = tr.querySelector('.ws-voice:not(.ws-voice--lead)') || tr.firstElementChild; tr.scrollBy({ left: d * (c.getBoundingClientRect().width + 16), behavior: 'smooth' }); }
    var p = sec.querySelector('[data-ws-voices-prev]'), n = sec.querySelector('[data-ws-voices-next]');
    if (p) p.addEventListener('click', function () { go(-1); });
    if (n) n.addEventListener('click', function () { go(1); });
  });
})();
(function () {
  /* ---------- Fallback if the bottle cut-out isn't uploaded yet ---------- */
  function swap(img) {
    if (img.dataset.wsSwapped) return;
    img.dataset.wsSwapped = '1';
    img.src = img.src.split('ws-bottle.webp')[0] + 'ws-product-bottle.jpg';
    img.style.objectFit = 'cover';
    img.style.filter = 'none';
    var call = img.parentNode && img.parentNode.querySelector('.ws-callout');
    if (call) call.style.top = '18.5%';
  }
  document.querySelectorAll('img[src*="ws-bottle.webp"]').forEach(function (img) {
    if (img.complete && !img.naturalWidth) swap(img);
    else img.addEventListener('error', function () { swap(img); });
  });
})();
